import { ArrowRight } from 'lucide-react';
import PageHeader from './ui/PageHeader';
import GlassCard from './ui/GlassCard';

const CareersPage = () => {

    const jobs = [
        {
            title: "Applied AI Engineer",
            type: "Fulltime",
            location: "Remote / Hyderabad",
            icon: (
                <svg className="w-full h-full absolute right-0 top-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="300" cy="100" r="150" className="stroke-purple-500/20" strokeWidth="40" />
                    <circle cx="300" cy="100" r="100" className="stroke-purple-500/30" strokeWidth="20" />
                    <path d="M100 300L300 100" className="stroke-purple-500/20" strokeWidth="4" />
                    <circle cx="100" cy="300" r="10" className="fill-purple-500/50 animate-pulse" />
                </svg>
            ),
            description: "Build and deploy state-of-the-art AI agents that solve complex enterprise problems.",
            link: "mailto:careers@antz.ai?subject=Regarding:Applied AI Engineer&body=Hi Antz, I am interested in the Applied AI Engineer role."
        },
        {
            title: "Data Engineer",
            type: "Fulltime",
            location: "Remote / Hyderabad",
            icon: (
                <svg className="w-full h-full absolute right-0 bottom-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50 350C50 350 150 250 350 250" className="stroke-blue-500/20" strokeWidth="40" strokeLinecap="round" />
                    <path d="M50 350C50 350 150 250 350 250" className="stroke-blue-500/10" strokeWidth="80" strokeLinecap="round" />
                    <circle cx="350" cy="250" r="20" className="fill-blue-500/50 animate-ping" />
                </svg>
            ),
            description: "Architect scalable data pipelines to fuel our autonomous agents.",
            link: "mailto:careers@antz.ai?subject=Regarding:Data Engineer&body=Hi Antz, I am interested in the Data Engineer role."
        },
        {
            title: "Data Scientist",
            type: "Fulltime",
            location: "Remote / Hyderabad",
            icon: (
                <svg className="w-full h-full absolute left-0 top-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 200Q100 100 200 200T400 200" className="stroke-green-500/20" strokeWidth="20" />
                    <path d="M0 250Q100 150 200 250T400 250" className="stroke-green-500/10" strokeWidth="20" />
                    <circle cx="200" cy="200" r="15" className="fill-green-500/50 animate-pulse" />
                </svg>
            ),
            description: "Derive insights and build predictive models to drive business value.",
            link: "mailto:careers@antz.ai?subject=Regarding:Data Scientist&body=Hi Antz, I am interested in the Data Scientist role."
        },
        {
            title: "Full Stack AI Engineer",
            type: "Fulltime",
            location: "Remote / Hyderabad",
            icon: (
                <svg className="w-full h-full absolute right-0 bottom-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="200" y="200" width="150" height="150" rx="20" className="stroke-yellow-500/20" strokeWidth="20" />
                    <rect x="250" y="250" width="150" height="150" rx="20" className="stroke-yellow-500/10" strokeWidth="20" />
                    <circle cx="275" cy="275" r="15" className="fill-yellow-500/50 animate-spin-slow" />
                </svg>
            ),
            description: "Create seamless end-to-end AI applications and user experiences.",
            link: "mailto:careers@antz.ai?subject=Regarding:Full stack AI Engineer&body=Hi Antz, I am interested in the Full stack AI Engineer role."
        }
    ];

    const values = [
        {
            icon: (
                <svg className="w-full h-full absolute right-0 top-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="100" cy="100" r="60" className="stroke-blue-500/20" strokeWidth="20" />
                    <circle cx="300" cy="300" r="60" className="stroke-blue-500/20" strokeWidth="20" />
                    <circle cx="300" cy="100" r="40" className="stroke-blue-500/10" strokeWidth="20" />
                    <circle cx="100" cy="300" r="40" className="stroke-blue-500/10" strokeWidth="20" />
                    <path d="M100 100L300 300" className="stroke-blue-500/20" strokeWidth="4" />
                    <path d="M300 100L100 300" className="stroke-blue-500/20" strokeWidth="4" />
                    <circle cx="200" cy="200" r="20" className="fill-blue-500 animate-pulse" />
                </svg>
            ),
            title: "Collaboration and Curiosity",
            description: "We foster a culture of questioning and shared discovery. Great ideas come from open minds working together."
        },
        {
            icon: (
                <svg className="w-full h-full absolute right-0 bottom-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50 350L150 200L250 300L350 50" className="stroke-yellow-500/20" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M50 350L150 200L250 300L350 50" className="stroke-yellow-500/10" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="350" cy="50" r="15" className="fill-yellow-500 animate-ping" />
                </svg>
            ),
            title: "Rapid Innovation",
            description: "Move fast and build things that matter. We ship code that changes industries."
        },
        {
            icon: (
                <svg className="w-full h-full absolute left-0 top-0" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M200 50C117.157 50 50 117.157 50 200C50 282.843 117.157 350 200 350C282.843 350 350 282.843 350 200" className="stroke-red-500/20" strokeWidth="20" strokeLinecap="round" />
                    <circle cx="200" cy="200" r="80" className="stroke-red-500/30" strokeWidth="20" />
                    <circle cx="200" cy="200" r="20" className="fill-red-500/50 animate-pulse" />
                </svg>
            ),
            title: "Impact Driven",
            description: "Your work directly empowers enterprises to become autonomous."
        }
    ];

    return (
        <div className="min-h-screen bg-background text-foreground pt-32 pb-20">
            <PageHeader
                prefix="BUILD THE"
                highlight="FUTURE"
                description="Join the autonomous revolution."
            />

            {/* Values Section */}
            <section className="container mx-auto px-4 mb-32">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {values.map((value, index) => (
                        <GlassCard key={index} className="group p-10 min-h-[300px] flex flex-col justify-end">
                            {/* Ambient Background Art */}
                            <div className="absolute inset-0 opacity-60 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                {value.icon}
                            </div>

                            <div className="relative z-10">
                                <h3 className="text-3xl font-bold text-foreground mb-4">{value.title}</h3>
                                <p className="text-muted-foreground leading-relaxed text-lg">
                                    {value.description}
                                </p>
                            </div>
                        </GlassCard>
                    ))}
                </div>
            </section>

            {/* Open Roles Section */}
            <section id="open-roles" className="container mx-auto px-4 mb-20">
                <h2 className="text-4xl font-bold text-center mb-16">Open Positions</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
                    {jobs.map((job, index) => (
                        <GlassCard key={index} className="group p-10 min-h-[300px] flex flex-col justify-between">
                            {/* Ambient Background Art */}
                            <div className="absolute inset-0 opacity-60 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                {job.icon}
                            </div>

                            <div className="relative z-10">
                                <div className="flex justify-between items-start mb-6">
                                    <div className="flex gap-3 text-sm text-muted-foreground">
                                        <span className="px-3 py-1 rounded-full bg-secondary/10 border border-border">{job.type}</span>
                                        <span className="px-3 py-1 rounded-full bg-secondary/10 border border-border">{job.location}</span>
                                    </div>
                                    <ArrowRight className="w-6 h-6 text-foreground -rotate-45 group-hover:rotate-0 transition-transform duration-300" />
                                </div>

                                <h3 className="text-3xl font-bold text-foreground mb-4">{job.title}</h3>
                                <p className="text-muted-foreground mb-8 leading-relaxed text-lg">
                                    {job.description}
                                </p>
                            </div>

                            <a
                                href={job.link}
                                className="relative z-10 inline-flex items-center justify-center w-full py-4 rounded-xl bg-secondary/10 text-foreground font-semibold hover:bg-secondary/20 border border-border transition-all duration-300"
                            >
                                Apply Now
                            </a>
                        </GlassCard>
                    ))}
                </div>
            </section>

            {/* General Application CTA */}
            <section className="container mx-auto px-4 text-center pb-20">
                <p className="text-muted-foreground mb-4">Don't see a fit?</p>
                <a href="mailto:careers@antz.ai" className="text-foreground font-semibold hover:text-primary transition-colors border-b border-border hover:border-primary pb-1">
                    Send us your resume at careers@antz.ai
                </a>
            </section>
        </div>
    );
};

export default CareersPage;
